import { Tab } from 'react-bootstrap';
import styled from 'styled-components';

export const TabContent = styled(Tab.Content)`
    width: 100%;
    height: 100%;
`;

export const TabPane = styled(Tab.Pane)`
    width: 100%;
    height: 100%;
    padding: 0 32px;
    display: flex;
    justify-content: center;
`;

export const StyledTabs = styled.div`
    display: flex;
    flex-wrap: wrap;
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 550px;
    background-color: ${({ theme }) => theme.colors.white};
`;
